var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Novelty Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Novelty Line",
      "file": "novelty"
    }
  }, [_vm._v(" 번아웃과 고급스러운 나염, 특별한 후가공, 다양한 패턴의 자카드와 엠보싱 등. 한국의 숙련된 기술로 가공한 특별한 품목들을 만나실 수 있습니다. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }